module.exports = __webpack_public_path__ + "static/tt-aus-white-61677ccbacc8cc2fc6bfe4349b555d61.png";